
/**
 * @description
 * Check if input is a valid image HTML5 file.
 *
 * @param {File} file The file to test
 * @returns {boolean}
 */
export function isValidImage(file) {
  return /\.(jpg|jpeg|png|gif|svg|webp|bmp|heic|heif)$/i.test(file.name);
}
